import { Report, ReportRow } from "./types";

/*---------------------------------------------------------------------------------------
  REPORT SEARCH
-----------------------------------------------------------------------------------------*/

export const transformReportRow = (res: any): ReportRow => {
  return {
    id: res.id,
    name: res.name,
    description: res.description
  };
};

/*---------------------------------------------------------------------------------------
    REPORT GET
-----------------------------------------------------------------------------------------*/

export const transformReport = (res: any): Report => {
  return {
    id: res.id,
    name: res.name,

  };
};
